// src/App.jsx
import { Suspense, useEffect } from 'react';
import WebsiteRoutes from './pages/WebsiteRoutes';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './lib/scrollToTop';
import LoadingSpinner from './components/ui/LoadingSpinner';
import GlobalPopupContainer from './components/ui/popups/GlobalPopupContainer';
import PaddleBootstrap from './components/paddle/PaddleBootstrap';
import { captureAttributionFromUrl } from './service-scripts/attribution';

const App = () => {
  useEffect(() => {
    captureAttributionFromUrl();
  }, []);

  return (
    <>
      <PaddleBootstrap />
      <Header />
      <CookieConsent />
      <ScrollToTop />
      <GlobalPopupContainer />
      <Suspense fallback={<LoadingSpinner />}>
        <main className="min-h-[90vh]">
          <WebsiteRoutes />
        </main>
      </Suspense>
      <Footer />
    </>
  );
};

export default App;
